import { anchorLink } from "../include/module";
import { toggleHeader } from "../include/module";
import { pageTop } from "../include/module";
import { menuCurrentImage } from "../include/module";
import { jsAnimation } from "../include/module";


(() => {

  anchorLink();
  toggleHeader();
  pageTop();
  menuCurrentImage();
  jsAnimation();

})();



// WEBPACK FOOTER //
// ./src/runnerz/assets/js/news/script.js